import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { PythonProvider } from "./context/PythonContext";


ReactDOM.render(<App />, document.getElementById('root'));

ReactDOM.createRoot(document.getElementById("root")).render(
  <PythonProvider>
    <App />
  </PythonProvider>
);
